




import { Component, Vue } from 'nuxt-property-decorator'
import { CATALOG_PATH } from '~/assets/config/path'
import { filterUrl } from '~/assets/filters/url'
import { NuxtAppOptions } from '~/node_modules/@nuxt/types'

@Component({
  layout: (ctx: NuxtAppOptions) =>
    ctx.$device.isMobileOrTablet ? 'mobile' : 'default',
})
export default class pageCatalogIndex extends Vue {
  private created(): void {
    this.$router.push(filterUrl(CATALOG_PATH))
  }
}
